import script from "./ShopExpress.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopExpress.vue?vue&type=script&lang=ts&setup=true"

import "./ShopExpress.vue?vue&type=style&index=0&id=5417d2c6&lang=scss"
import "./ShopExpress.vue?vue&type=style&index=1&id=5417d2c6&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5417d2c6"]])

export default __exports__